import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { formatMoney, getInlineLoader } from "../Helpers";
import { MdLocationPin, MdStar } from "react-icons/md";
import MobileInterface from "../MobileInterface";
import logo from '../assets/logo.png';
import { FaRegCreditCard, FaRegUser } from "react-icons/fa";
import { PiHandDepositFill, PiMoneyWavy } from "react-icons/pi";
import { IoIosCart } from "react-icons/io";
import { RiBilibiliLine, RiBillLine, RiMessage2Line } from "react-icons/ri";
import { FaArrowsDownToPeople, FaMoneyBills, FaMoneyBillTrendUp, FaPeopleRoof } from "react-icons/fa6";
import { STR_FLOAT_LOAN_SERVICE, STR_INBOX, STR_NEARBY_AGENTS, STR_NEARBY_SUPER_AGENTS, STR_REPORT_ANALYSIS, STR_REQUEST_CASH, STR_REQUEST_FLOAT, STR_REQUEST_FLOAT_CASH, STR_REQUESTS_FEED } from "../Strings";


export default function HomeMenu(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	const menuItemStyle = {
		padding: "15px",
		borderRadius: "10px"
	}
	const menuItemSize = 64;
	const menuItemClassnames = "mShadow3 text-secondary";
	const menuItemTitleStyle = {
		fontSize: "12px",
		fontFamily: "FontBold",
		marginTop: "5px",
	}

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [])

	if (ready) {
		return (
			<div className="row" style={{ marginTop: "30px", marginBottom: "20px" }}>
				<div 
					className="col-4 text-center mb-4"
					onClick={() => {
						
						appContext.navTo({
							item: 'home',
							subItem: 'request_float',
						})
					}}
				>
					<FaMoneyBillTrendUp
						size={menuItemSize}
						style={menuItemStyle}
						className={menuItemClassnames}
					/>

					<h6
						style={menuItemTitleStyle}
					>
						{STR_REQUEST_FLOAT_CASH[appContext.language]}
					</h6>
				</div>

				

				<div 
					className="col-4 text-center mb-4"
					onClick={() => {
						appContext.navTo({
							item: 'home',
							subItem: 'agent_requests_feed',
						})
					}}
				>
					<FaArrowsDownToPeople
						size={menuItemSize}
						style={menuItemStyle}
						className={menuItemClassnames}
					/>

					<h6
						style={menuItemTitleStyle}
					>
						{STR_REQUESTS_FEED[appContext.language]}
					</h6>
				</div>


				<div 
					className="col-4 text-center mb-4"
					onClick={() => {
						appContext.navTo({
							item: 'home',
							subItem: 'nearby_agents',
						})
					}}
				>
					<FaPeopleRoof
						size={menuItemSize}
						style={menuItemStyle}
						className={menuItemClassnames}
					/>

					<h6
						style={menuItemTitleStyle}
					>
						{STR_NEARBY_AGENTS[appContext.language]}
					</h6>
				</div>

				<div 
					className="col-12 text-center mb-4"
					onClick={() => {
						appContext.navTo({
							item: 'home',
							subItem: 'float_loan_service',
						})
					}}
				>
					<div
						style={{
							paddingLeft: "15px",
							paddingRight: "15px",
						}}
					>
						<div 
							className="mShadow3 text-secondary font-semi-bold"
							style={{
								padding: "10px",
								borderRadius: "15px",
								fontSize: "14px"
							}}
						>
							<h6
								className="text-secondary"
							>
								<PiMoneyWavy size={52}/>
								
							</h6>	

							<span className="text-dark">{STR_FLOAT_LOAN_SERVICE[appContext.language]}</span>
						</div>
					</div>
				</div>

				
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}